import React, { Component, Fragment } from "react";
import { HashRouter, Switch, Route, withRouter } from "react-router-dom";
// import Header from "./layout/header/header3";
import Header from "./layout/header/Header";
import Footer from "./layout/footer/footer";
import Index from "./pages/Index/index7";
import $ from "jquery";
import { connect } from "react-redux";
import "antd/dist/antd.css";


import "./App.css";
import "./Vendor.js";
import "./theme.scss"
import './index.css';

import Login from "./pages/account/signin/signin2";
import ForgotPassword from "./pages/account/forgotpassword/index";
import Signup from "./pages/account/signup";
import Scrolltop from "./layout/back-to-top";
import Home from "./pages/homepage";
import CreateNewProject from "./pages/createProject";
import ProjectsPage from "./pages/projectsPage";
import CreateForm from "./pages/create-form";
import Form from "./pages/Form";
import UserManagement from "./pages/userManagement";
import FormArchive from "./pages/formArchive";
import CreateObject from "./pages/create-object";
import Research from "./pages/research";
import AdminPage from "./pages/adminPage";
import EditForm from "./pages/edit-form";
import FormEdit from "./pages/edit-form/form-edit";
import ScreenWrapper from "./layout/ScreenWrapper";
import ResearchResults from "./pages/research/results";
import { logoutUser } from "./utils/API";
import RecycleDocs2 from "./pages/Form/components/RecycleDocs2";
import RecycleDocs3 from "./pages/Form/components/RecycleDocs3";
import RecycleDocs4 from "./pages/Form/components/RecycleDocs4";
import RecycleDocs5 from "./pages/Form/components/RecycleDocs5";
import ConnectionPage from "./pages/adminPage/connections";
import MonitoringPage from "./pages/adminPage/monitoring";
import LicencePage from "./pages/adminPage/licence";
import DraftFormPage from "./pages/Form/draftsPage";
import ChangeTheme from "./pages/utilities/changeTheme/ChangeTheme";
import ChangePassword from "./pages/change-password";
import SetPassword from "./pages/auth/set-password";
import ToastComponent from "./widgets/toast/toast";
import Folder from "./pages/folder/index.jsx";
import EditObject from "./pages/edit-object";

class App extends React.Component {
  constructor(props) {
    super(props);
  }

  getUrl(pathname) {
    let pathArray = pathname.split("/");
    return `/${pathArray[1]}` === "/coming-soon"
      ? true
      : `/${pathArray[1]}` === "/maintenance"
        ? true
        : `/${pathArray[1]}` === "/page-not-found"
          ? true
          : false;
  }
  setHeader(pathname) {
    let pathArray = pathname.split("/");
    return `/${pathArray[1]}` === "/theme" ? true
      : `/${pathArray[1]}` === "/index2"
        ? true
        : `/${pathArray[1]}` === "/index3"
          ? true
          : `/${pathArray[1]}` === "/index4"
            ? true
            : `/${pathArray[1]}` === "/index5"
              ? true
              : `/${pathArray[1]}` === "/index9"
                ? true
                : `/${pathArray[1]}` === "/home"
                  ? true
                  : `/${pathArray[1]}` === "/create-new-project"
                    ? true
                    : `/${pathArray[1]}` === "/recycledocs2"
                      ? true
                      : `/${pathArray[1]}` === "/recycledocs3"
                        ? true
                        : `/${pathArray[1]}` === "/recycledocs4"
                          ? true
                          : `/${pathArray[1]}` === "/recycledocs5"
                            ? true
                            : `/${pathArray[1]}` === "/projects"
                              ? true
                              : `/${pathArray[1]}` === "/create-form"
                                ? true
                                : `/${pathArray[1]}` === "/form"
                                  ? true
                                  : `/${pathArray[1]}` === "/user-management"
                                    ? true
                                    : `/${pathArray[1]}` === "/form-archive"
                                      ? true
                                      : `/${pathArray[1]}` === "/create-object"
                                        ? true
                                        : `/${pathArray[1]}` === "/research"
                                          ? true
                                          : `/${pathArray[1]}` === "/edit-form"
                                            ? true
                                            : `/${pathArray[1]}` === "/admin"
                                              ? true
                                              : `/${pathArray[1]}` === "/form-edit"
                                                ? true
                                                : `/${pathArray[1]}` === "/folder"
                                                  ? true
                                                  : `/${pathArray[1]}` === "/change-password"
                                                    ? true
                                                  : false;
  }
  setFooter(pathname) {
    let pathArray = pathname.split("/");
    return `/${pathArray[1]}` === "/theme" ? true
      : `/${pathArray[1]}` === "/home"
        ? true
        : `/${pathArray[1]}` === "/create-new-project"
          ? true
          : `/${pathArray[1]}` === "/projects"
            ? true
            : `/${pathArray[1]}` === "/create-form"
              ? true
              : `/${pathArray[1]}` === "/form"
                ? true
                : `/${pathArray[1]}` === "/recycledocs2"
                  ? true
                  : `/${pathArray[1]}` === "/recycledocs3"
                    ? true
                    : `/${pathArray[1]}` === "/recycledocs4"
                      ? true
                      : `/${pathArray[1]}` === "/recycledocs5"
                        ? true
                        : `/${pathArray[1]}` === "/user-management"
                          ? true
                          : `/${pathArray[1]}` === "/form-archive"
                            ? true
                            : `/${pathArray[1]}` === "/create-object"
                              ? true
                              : `/${pathArray[1]}` === "/research"
                                ? true
                                : `/${pathArray[1]}` === "/edit-form"
                                  ? true
                                  : `/${pathArray[1]}` === "/admin"
                                    ? true
                                    : `/${pathArray[1]}` === "/form-edit"
                                      ? true
                                      : `/${pathArray[1]}` === "/folder"
                                        ? true
                                        : false;
  }

  componentDidMount() {
    let theme = localStorage.getItem('theme');
    if (theme) {
	    document.documentElement.setAttribute('data-theme', theme);
    }
  }

  render() {
    const { location } = this.props;
    return (
      <Fragment>
        {this.getUrl(location.pathname) ? (
          <Switch>
            {/* <Route path="/coming-soon" component={ComingSoon} />
            <Route path="/maintenance" component={Maintenance} />
            <Route path="/page-not-found" component={PageNotFound} /> */}
          </Switch>
        ) : (
          <div className="page-wrapper min-h-screen flex flex-col">
            {this.setHeader(location.pathname) ? null : <Header />}
            <div className="flex-1"></div>

            <Switch>
              <Route exact path="/" component={Index} />
              {/* Login */}
              <Route path="/login" component={Login} />
              <Route path="/sign-up" component={Signup} />
              <Route path="/forgot-password" component={ForgotPassword} />
              <Route path="/auth/set-password" component={SetPassword} />
              {/* Projects */}
              {/* <Route path="/projects" component={Projects} /> */}
            </Switch>

            <Switch>
              {/* {this.setHeader(location.pathname) ? null : <Header />} */}
              {/* <Route path="/" */}
              <Route exact path="/home" render={() => <ScreenWrapper Component={Home} page="home" />} />
              {/* <Route exact path="/home" render={() => <ScreenWrapper Component={Home} />} /> */}

              {/* <Route
                exact
                path="/create-new-project"
                render={() => <ScreenWrapper Component={CreateNewProject} page="create-new-project" />}
              /> */}
              <Route exact path="/projects/:project_name" render={() => <ScreenWrapper Component={ProjectsPage} page="projects" />} />
              <Route exact path="/create-form" render={() => <ScreenWrapper Component={CreateForm} page="projects" />} />
              <Route exact path="/edit-form" render={() => <ScreenWrapper Component={EditForm} page="projects" />} />
              {/* to do add id in form edit below */}
              <Route exact path="/form-edit" render={() => <ScreenWrapper Component={FormEdit} page="projects" />} />
              <Route exact path="/form/:form_name/documents" render={() => <ScreenWrapper Component={Form} page="projects" />} />
              <Route exact path="/form/:form_name/drafts" render={() => <ScreenWrapper Component={DraftFormPage} page="projects" />} />
              <Route exact path="/user-management" render={() => <ScreenWrapper Component={UserManagement} page="projects" />} />
              <Route exact path="/form/:form_name/form-archive" render={() => <ScreenWrapper Component={FormArchive} page="projects" />} />
              <Route exact path="/form/:form_name/create-object" render={() => <ScreenWrapper Component={CreateObject} page="projects" />} />
              <Route exact path="/form/:form_name/edit-object/:object_id" render={() => <ScreenWrapper Component={EditObject} page="projects" />} />
              <Route exact path="/research" render={() => <ScreenWrapper Component={Research} page="projects" />} />
              <Route exact path="/folder" render={() => <ScreenWrapper Component={Folder} page="projects" />} />
              <Route exact path="/admin/users" render={() => <ScreenWrapper Component={AdminPage} />} />
              <Route exact path="/admin/connections" render={() => <ScreenWrapper Component={ConnectionPage} />} />
              <Route exact path="/admin/monitoring" render={() => <ScreenWrapper Component={MonitoringPage} />} />
              <Route exact path="/admin/licence" render={() => <ScreenWrapper Component={LicencePage} />} />
              <Route exact path="/folder" render={() => <ScreenWrapper Component={Folder} />} />
              <Route exact path="/signout" render={() => logoutUser()} />
              <Route exact path="/recycledocs2/:form_name" render={() => <ScreenWrapper Component={RecycleDocs2} page="projects" />} />
              {/* <Route exact path="/recycledocs3/:form_name/:name" render={() => <ScreenWrapper Component={RecycleDocs3} page="projects" />} /> */}
              {/* <Route exact path="/recycledocs4/:form_name" render={() => <ScreenWrapper Component={RecycleDocs4} page="projects" />} /> */}
              <Route exact path="/recycledocs5/:form_name/:id" render={() => <ScreenWrapper Component={RecycleDocs5} page="projects" />} />
              <Route exact path="/research/results" render={() => <ScreenWrapper Component={ResearchResults} page="projects" />} />

              <Route exact path="/theme" render={() => <ScreenWrapper Component={ChangeTheme} page="projects" />} />
              <Route exact path="/change-password" render={() => <ScreenWrapper Component={ChangePassword} page="projects" />} />
            </Switch>

            <div className="flex-1"></div>
            {this.setFooter(location.pathname) ? null : <Footer />}
            <Scrolltop />
          </div>
        )}
        <ToastComponent />
      </Fragment>
    );
  }
}



// const AppMapStateToProps = (state) => {
//   return {
//     products: state.data.products,
//   };
// };

// const AppMapDispatchToProps = (dispatch) => {
//   return {};
// };

// export default connect(
//   AppMapStateToProps,
//   AppMapDispatchToProps
// )(withRouter(App));

export default App;
